<template>
    <b-container>

        <content-placeholders v-if="physicalSkus.length">

        </content-placeholders>
        <template v-else>
            <b-table-simple class="mt-5" hover>
                <b-thead>
                    <b-tr>
                        <b-th>State</b-th>
                        <b-th colspan="1">PreK</b-th>
                        <b-th colspan="1">K</b-th>
                        <b-th colspan="1">1</b-th>
                        <b-th colspan="1">2</b-th>
                        <b-th colspan="1">3</b-th>
                        <b-th colspan="1">4</b-th>
                        <b-th colspan="1">5</b-th>
                        <b-th colspan="1">6</b-th>
                        <b-th colspan="1">7</b-th>
                        <b-th colspan="1">8</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="({state, pubs},i) in statePubs" :key="`state_${i}`">
                        <b-th>
                            {{state}}
                        </b-th>

                        <b-th v-for="(i) in 10" colspan="1" v-html="tryGetSku(pubs, i-2)" :key="`statePub_${i}`">

                        </b-th>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </template>
    </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
    name: "PageMapping",
    computed: {
        ...mapState({
            selectedState: state => state.selectedState,
            selectedYear: state => state.selectedYear,

        }),
        ...mapGetters({
            newSocialStudiesPublications: 'getNewSocialStudiesPublications',
            adoptedSocialStudiesPublications: 'getAdoptedSocialStudiesPublications',
            sciencePublications: 'getSciencePublications',
            summerPublications: 'getSummerPublications',
            healthPublications: 'getHealthWellnessPublications',
            prekPublications: 'getPreKPublications',
            exploreScience: 'getExploreSciencePublications',

        }),
        tableItems() {
            let items =[];
            return items;
        },

    },
    data: () => ({
        // tableFields: ['State', {key:'-1',label:'PreK'}, {key:'0',label:'K'}, '1', '2', '3', '4', '5', '6', '7', '8']
        statePubs: [],
        physicalSkus: {},
    }),
    created() {
        this.statePubs = [this.formatStateData(this.newSocialStudiesPublications)];
        this.getPhysicalSkus();
    },
    methods: {
        formatStateData(stateData) {
            let items = _.filter(this.newSocialStudiesPublications, (x) => x.language === 'en');
            let byGrade = _.groupBy(items, 'grade');
            return {
                state: 'AL',
                pubs: byGrade,
            }
        },
        tryGetSku(pubs, grade) {
            if (!pubs.hasOwnProperty(grade))
                return "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";

            return this.physicalSkus[pubs[grade][0].legacy_id];
        },
        getPhysicalSkus() {
            this.$store.dispatch('getPhysicalProducts')
                .then((data) => {
                    for (let i = 0; i < data.length; i++) {
                        this.physicalSkus[data[i].ID] = data[i].sku
                    }
                    console.log(this.physicalSkus)
                    this.$forceUpdate();
                });
        }
    }
}
</script>

<style scoped>

</style>